<template>
  <a-modal
    :visible="visible"
    width="702px"
    :mask-closable="false"
    :title="title"
    :confirm-loading="btnIsLoading"
    @ok="$emit('handleSubmit')"
    @cancel="$emit('onCancel')"
  >
    <basic-form
      ref="basicForm"
      :form-data="formData"
    >
      <template #title>
        <a-input
          v-decorator="[
            'title',
            {
              rules: [
                {
                  required: true,
                  message: '请输入广告标题',
                },
              ],
            },
          ]"
          placeholder="请输入广告标题"
        />
      </template>
      <template #url>
        <a-input
          v-decorator="[
            'url',
            {
              rules: [
                {
                  required: true,
                  message: '请输入文章ID',
                },
              ],
            },
          ]"
          placeholder="请输入文章ID"
        />
      </template>
      <template #description>
        <a-textarea
          v-decorator="[
            'description',
            { rules: [{ required: true, message: '请输入' }] },
          ]"
          rows="3"
          placeholder="请输入"
          maxlength="150"
        />
      </template>
      <template #content>
        <a-textarea
          v-decorator="[
            'content',
            { rules: [{ required: true, message: '请输入' }] },
          ]"
          rows="3"
          placeholder="请输入"
          maxlength="150"
        />
      </template>
      <template #image>
        <a-upload
          v-decorator="[
            'image',
            {
              initialValue: [],
              rules: [{ required: true, message: '请上传图片' }] ,
              valuePropName: 'fileList',
              getValueFromEvent: normFile,
            },
          ]"
          name="upload"
          accept=".jpg,.png,.jpeg"
          list-type="picture-card"
          class="avatar-uploader"
          :show-upload-list="false"
          :data="{fileType:'img',}"
          :action="`${uploadUrl}fileup/up`"
          :before-upload="beforeUpload"
        >
          <img
            v-if="$refs.basicForm && $refs.basicForm.form.getFieldValue('image').length === 1 && $refs.basicForm.form.getFieldValue('image')[0].status === 'done'"
            width="100"
            height="100"
            :src="$refs.basicForm.form.getFieldValue('image')[0].url"
            alt="avatar"
          >
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">
              上传
            </div>
          </div>
        </a-upload>
      </template>
      <template #list_order>
        <a-input-number
          v-decorator="['list_order',{rules: [
            { required: true, message: '请输入排序' },
          ],}]"
          placeholder="请输入排序"
          style="width:100%"
        />
      </template>
    </basic-form>
  </a-modal>
</template>
<script>
import { formDataPage } from '../data/index';
export default {
  props: ['visible', 'title', 'btnIsLoading'],
  data() {
    return {
      formData: formDataPage,
      loading: false,
    };
  },
  methods: {
    normFile(e) {
      if (e && e.file.status === 'uploading') {
        this.loading = true;
      }
      if(e && e.file.status === 'done'){
        const fileList = [{
          uid: e.file.response.data.id,
          status: 'done',
          name: 'img',
          url: e.file.response.data.url,
        }];
        this.loading = false;
        return fileList;
      }
      return e.fileList;
    },
    // 上传前
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('图片小于10M！');
      }
      return isLt2M;
    },
  },
};
</script>
<style lang="scss" scoped>
.client-modal-wrapper {
}
</style>
